import { withInstall } from '../../utils'

import _Statistic from './src/statistic.vue'

export const SdStatistic = withInstall(_Statistic)
export default SdStatistic

export * from './src/statistic'
